import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validationScheme in signup procedure */
const RiskRegisterScheme = Yup.object().shape({
  riskTitle: Yup.string()
    .trim()
    .required('Risk title is required')
    .min(5, 'Risk title must be at least 5 characters.')
    .matches(
      /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9 ,.\-_():&'/]+$/,
      "Risk title must contain at least one letter or number, and only allowed symbols (, . - _ ( ) : & ' /)"
    ),
  riskDescription: Yup.string()
    .trim()
    .required('Risk Description is required')
    .min(10, 'Risk description must be at least 10 characters.')
    .matches(
      /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9 ,.\-_():&'/]+$/,
      "Risk description must contain at least one letter or number, and only allowed symbols (, . - _ ( ) : & ' /)"
    ),
  affectedStakeholders: Yup.string()
    .trim()
    .required('Affected Stakeholders is required')
    .matches(
      /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9 ,.\-_():&'/]+$/,
      "Affected stakeholders must contain at least one letter or number, and only allowed symbols (, . - _ ( ) : & ' /)"
    ),
  mitigationPlan: Yup.string()
    .trim()
    .required('Mitigation plan is required')
    .matches(
      /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9 ,.\-_():&'/]+$/,
      "Mitigation plan must contain at least one letter or number, and only allowed symbols (, . - _ ( ) : & ' /)"
    ),
  // residualriskowner: Yup.string().trim().required('Dataset Name is required'),
  // duedate: Yup.string().trim().required('Dataset Name is required'),
  riskType: Yup.string().trim().required('Risk type is required'),
  likelihood: Yup.string().trim().required('Likelihood is required'),
  impact: Yup.string().trim().required('Impact is required'),
  mitigationStatus: Yup.string()
    .trim()
    .required('Mitigation status is required'),
  residualRiskLevel: Yup.string().trim().required('Residual risk is required'),
});

export { RiskRegisterScheme };
